import { SvgIcon, SvgIconProps } from "@mui/material";

export default function PasswordIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 27">
      <path
        fill="#62C3EE"
        fillRule="nonzero"
        d="M23.17 2.284A7.652 7.652 0 0 0 17.7 0a7.65 7.65 0 0 0-5.468 2.284 7.841 7.841 0 0 0-1.7 8.443l.034.086L.633 20.832a.705.705 0 0 0-.203.495V26.3c0 .386.31.7.694.7H4.281c.383 0 .68-.313.68-.7l.005-4.122 4.133-.002H9.1a.693.693 0 0 0 .694-.7v-3.119l3.9-3.93a7.861 7.861 0 0 0 4.078 1.15c2.034 0 3.95-.804 5.397-2.263 3.014-3.04 3.014-7.988 0-11.03zm-.785 5.113l-1.08 1.089a.552.552 0 0 1-.785 0l-3.5-3.531a.564.564 0 0 1 0-.792l1.08-1.089a.552.552 0 0 1 .785 0l3.5 3.531a.563.563 0 0 1 0 .792z"
      />
    </SvgIcon>
  );
}
